import React from "react";
import './panellayout.css';
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { Header } from '../../components/Header';
import {Topbar} from '../../components/Topbar'
import { Outlet } from "react-router-dom";

const Panellayout = () => {
  return (
    <>
      <ToastContainer 
        position="top-right"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <div className="app-layout">
        <Header />
        <div className="main-content">
          <Topbar />
          <div className="content-area">
            <Outlet />
          </div>
        </div>
      </div>
    </>
  );
};

export default Panellayout;
